import React, { Component } from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"
import { DckSelectors, DckActionCreators } from "dck-redux"

import SmartTable from "../SmartTable"
import * as ItemTypes from "../../redux/items/types"

class ListBatches extends Component {

  renderItemToRemove = item => `${item.msisdn} : ${item.imei}`

  render() {
    return (
      <SmartTable
        buttonsDisable={true}
        items={this.props.batches}
        renderItemToRemove={this.renderItemToRemove}
      >
        <TableHeaderColumn
          dataField="msisdn"
          dataAlign="center"
          dataSort={true}
          filter={{ type: "TextFilter", delay: 1000 }}
          isKey={true}
        >
          MSISDN
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="imei"
          dataAlign="center"
          dataSort={true}
          filter={{ type: "TextFilter", delay: 1000 }}
        >
          IMEI
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="status"
          dataAlign="center"
          dataSort={true}
          filter={{ type: "TextFilter", delay: 1000 }}
        >
          Status
        </TableHeaderColumn>
      </SmartTable>
    )
  }

  componentDidMount() {
    this.props.loadBatches()
  }
}

const mapStateToProps = state => {
  const batches = DckSelectors.selectAllItems(state, ItemTypes.Batch)
  return { batches }
},

mapDispatchToProps = dispatch => ({
  loadBatches: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Batch)),
  setSelectedBatches: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Batch, id))
})

export default connect(mapStateToProps, mapDispatchToProps)(ListBatches)



// WEBPACK FOOTER //
// ./src/components/Batches/List.js